/* eslint-disable import/order */
import React from 'react';
import { MenuIdProfile } from '@jira/navigation-apps__constants/src/MenuIdProfile.tsx';
import { SidebarIdPersonalSettings } from '@jira/navigation-apps__constants/src/SidebarIdPersonalSettings.tsx';
import { personalSettingsNotificationsEntryPoint } from '@jira/spa-apps__personal-settings-notifications/src/personalSettingsNotificationsEntryPoint.entrypoint.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { getNavigationForgePersonalSettingsPageResources } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { getNotificationsPersonalSettingsPath } from '@jira/personal-settings__paths/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { notificationsPersonalSettingsRoute } from '@jira/router-routes__personal-settings-routes/src/notificationsPersonalSettingsRoute.tsx';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';
import { PersonalSettingsNotificationsAppSkeleton } from '@jira/platform__skeletons/src/ui/personal-settings-notifications/PersonalSettingsNotificationsAppSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';

const personalSettingsNotificationsEntryPointPage = createPageEntryPoint({
	main: personalSettingsNotificationsEntryPoint,
});

export const notificationsPersonalSettingsRouteEntry: Route = createEntry(
	notificationsPersonalSettingsRoute,
	() => ({
		group: 'personal-settings',
		skeleton: PersonalSettingsNotificationsAppSkeleton,
		// eslint-disable-next-line no-restricted-syntax
		component: () => <ScreenRedirect to={getNotificationsPersonalSettingsPath()} />,
		layout: globalLayout,

		navigation: {
			sidebarId: SidebarIdPersonalSettings,
			menuId: MenuIdProfile,
		},

		resources: [
			...getNavigationResources(),
			getConsolidationStateResource(),
			...getNavigationForgePersonalSettingsPageResources(),
		],

		pageId: 'personal-settings-notifications',

		entryPoint() {
			return personalSettingsNotificationsEntryPointPage;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
